import _ from 'lodash'

export const toCamelCase = (text: string) => _.camelCase(text)
export const toUpperCase = (text: string) => _.toUpper(text)

export const findElementIndexById = (uuid: string, elementList: FormElement[]): number => {
    return elementList.findIndex(e => e.uuid === uuid)
}

export const findElementIndex = (element: FormElement, elementList: FormElement[]): number => {
    return findElementIndexById(element.uuid, elementList)
}

export const findElementById = (uuid: string, elementList: FormElement[]): FormElement => {
    return elementList.find(e => e.uuid === uuid)
}

export const checkLabelAlreadyExists = (label: string, element: FormElement, elementList: FormElement[]) => {
    const duplicated: FormElement[] = []

    const recursiveCheck = (label: string, elements: FormElement[]) => {
        for(const e of elements) {
            if (e.children) recursiveCheck(label, e.children)
            if (e.props.label === label && e.uuid != element.uuid) duplicated.push(e)
        }
        return
    }

    recursiveCheck(label, elementList)

    return { alreadyExists: duplicated.length > 0, elements: duplicated }
}

/**
 * Converts schemas in versions prior to v2
 * */
export const convertSchemaVersion = (schema: FormSchema) => {
    return schema ?
        {
            ...schema,
            elements: schema.elements.map(e => {
                if (e.children) {
                    const children = e.children.map(child => {
                        return {...child, parent: e.uuid}
                    })
                    return {...e, children: children}
                } else {
                    return e
                }
            })
        } : undefined
}

export const countElements = (elements: FormElement[]) => {
    return elements.length > 0 ?
        elements
            .map(e => e.children?.length ?? 1)
            .reduce((a, b) => a + b)
        : 0
}

export const createUUID = (elements: FormElement[]) => {
    if (elements.length === 0) return 'element1'

    const elementCount = countElements(elements)

    const uuids = elements.map(e => {
        return [
            e.uuid,
            ...e.children?.map(c => c.uuid) ?? []
        ]
    }).reduce((a, b) => [...a, ...b])

    const recursiveSearch = (count: number) => {
        const uuid = `element${count}`
        if (uuids.includes(uuid)) return recursiveSearch(count + 1)
        else return uuid
    }

    return recursiveSearch(elementCount)

}